import { cached } from '@porotutu/react'
import { listQueryOf } from '@porotutu/react/paging'
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { permittedRoute, signedInRoute } from '@/router/root'
import { CRM_ORDER_SORTABLE, ORDER_STATUSES } from '../vocabulary'
import { orderQuery, ordersQuery } from './queries'

const orderSearch = (raw: Record<string, unknown>) =>
  listQueryOf(raw, CRM_ORDER_SORTABLE, ORDER_STATUSES, ['customer_id'])

export const ordersRoute = createRoute({
  getParentRoute: () => signedInRoute,
  beforeLoad: permittedRoute('orders'),
  path: '/orders',
  validateSearch: orderSearch,
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps }) => context.queryClient.query(cached(ordersQuery(deps))),
  component: lazyRouteComponent(() => import('./pages'), 'OrdersPage'),
})

export const orderRoute = createRoute({
  getParentRoute: () => signedInRoute,
  beforeLoad: permittedRoute('orders'),
  path: '/orders/$id',
  validateSearch: orderSearch,
  loader: ({ context, params }) => context.queryClient.query(cached(orderQuery(params.id))),
  component: lazyRouteComponent(() => import('./pages'), 'OrderPage'),
})

export const orderRoutes = [ordersRoute, orderRoute]
